<template>
    <div v-if="pass != undefined">
        <div id="pass_detail" class="pass">
            <b-row class="pass_title align-items-center">
                <b-col cols="9">
                    <h5>
                        <icon name="user" scale="1"></icon> {{ pass.pass_holder_name }}
                    </h5>
                    <div class="pass_type_name">{{ pass.type_name }}</div>
                </b-col>
                <b-col cols="3">
                    <div v-if="pass.image" class="text-center">
                        <b-img :src="getImageUrl(pass.image)" fluid class="id-photo" alt="Pass holder photo" />
                    </div>
                    <div v-else class="id-photo placeholder-photo"></div>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="4">Type</b-col>
                <b-col class="text-capitalize">{{ pass.pass_type }} / {{ pass.pass_age }}</b-col>
            </b-row>

            <b-row v-if="hasOption('isSeasonPass')">
                <b-col cols="4">Season Pass</b-col>
                <b-col class="text-capitalize">{{ isOptionTrue('isSeasonPass') ? 'Yes' : 'No' }}</b-col>
            </b-row>

            <b-row v-if="hasOption('isPrivileged')">
                <b-col cols="4">Summit</b-col>
                <b-col class="text-capitalize">{{ isOptionTrue('isPrivileged') ? 'Yes' : 'No' }}</b-col>
            </b-row>

            <b-row>
                <b-col cols="4">Last Use</b-col>
                <b-col v-if="pass.last_check_in_time">{{ lastCheckInTime }} at {{ pass.last_check_in_org_name }}</b-col>
                <b-col v-else>None</b-col>
            </b-row>

            <b-row>
                <b-col cols="4">Pass ID</b-col>
                <b-col>{{ pass.barcode }}</b-col>
            </b-row>

            <b-row>
                <b-col cols="4">RFID</b-col>
                <b-col>{{ pass.rfid }}</b-col>
            </b-row>

            <b-row>
                <b-col cols="4">Expiry Date</b-col>
                <b-col>
                    {{ expiry }}
                    <div v-if="pass.is_expired" class="expired danger">EXPIRED</div>
                </b-col>
            </b-row>

            <b-row v-if="pass.days_remaining != undefined">
                <b-col cols="4">Days Left</b-col>
                <b-col class="days_remaining">{{ pass.days_remaining }}
                    <span class="expired danger" v-if="pass.days_remaining < 1"> VOID</span>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="4"></b-col>
                <b-col>
                    <div v-if="pass.disabled" class="expired danger">DISABLED (stolen/lost)</div>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="4">Comments</b-col>
                <b-col>{{ pass.notes }}</b-col>
            </b-row>
        </div>
    </div>
</template>


<script>
import api from '../api';
import moment from 'moment';
import config from "../constants";
moment.locale('en-nz');

export default {
    name: "Pass",
    props: ["pass"],
    data() {
        return {
            notes: ""
        };
    },
    computed: {
        expiry() {
            return this.pass.expiry_date == null ? "" : moment(this.pass.expiry_date).format('DD MMM YYYY')
        },
        lastCheckInTime() {
            return moment(this.pass.last_check_in_time).format('lll')
        }
    },
    methods: {
        getImageUrl(image) {
            return `${config.profilePhotosUrl}/${this.pass.image}`;
        },
        hasOption(optionName) {
            return this.pass.options.find(option => option.optionName === optionName);
        },
        isOptionTrue(optionName) {
            return this.pass.options.find(option => option.optionName === optionName && option.optionValue === 'true');
        }
    }
};
</script>

<style scoped>
.pass {
    border-radius: 1em;
    padding: 0 1em 1em 1em;
    box-shadow: 0.1em 0.1em 0.5em black;
    width: 30em;
    font-size: 0.8em;
    background: #eee;
    margin-top: 20px;
    margin-bottom: 40px;
    margin-left: 20px;
}

.pass .pass_title {
    background: #333;
    color: white;
    border-radius: 1em 1em 0 0;
    padding: 0.5em;
    margin-bottom: 0.5em;
    border-bottom: 0.5em solid #35A9CE;
}

.pass .pass_type_name {
    font-size: 1.2em;
}

.pass .expired {
    font-weight: bold;
    font-family: 'Courier New', Courier, monospace;
    font-size: 1.5em;
    color: red;
}

.pass .days_remaining {
    font-weight: bold;
    font-size: 1.5em;
}

.id-photo {
    max-width: 100%;
    max-height: 5em;
    border-radius: 0.25em;
    object-fit: cover;
    border: 2px solid white;
}
.id-photo {
  max-width: 100%;
  max-height: 5em;
  border-radius: 0.25em;
  object-fit: cover;
  border: 2px solid white;
}

.placeholder-photo {
  background-color: #ccc;
  width: 100%;
  height: 5em;
  display: block;
}

</style>



// WEBPACK FOOTER //
// src/components/Pass.vue